import { MtxButton, MtxGrid } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import ContractTutorials from '@/components/ContractTutorials';
import { FamilleCardReprendreSouscription } from '@/components/Dico';
import useContractTutorials from '@/hooks/useContractTutorials';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

import styles from './styles.module.css';

import type { OperationKey, TutorielOperation } from '@/types/videoTutorials';

type Props = {
  contractName?: string | null;
  insuranceLogo?: string | null;
  isLogo: boolean;
  isAsideInfo: boolean;
  insuranceLink: string;
  family?: string | null;
  description?: string;
  cancelablePeriod?: number | null;
  onRequestCancellation?: () => void;
  operation?: OperationKey | TutorielOperation;
};

const CardGererContrat = ({
  contractName,
  insuranceLogo,
  isLogo,
  isAsideInfo,
  insuranceLink,
  family,
  description,
  cancelablePeriod,
  onRequestCancellation,
  operation,
}: Props) => {
  const { t } = useTranslation();
  const cancelLabel = cancelablePeriod === 14 ? t('common.retractableCTA') : t('common.cancelableCTA');

  const handlePartnerSpaceClick = () => {
    globalThis.open(insuranceLink, '_blank', 'noopener,noreferrer');
    void void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'espace partenaire',
      event_detail_1: 'cta',
    });
  };

  const contractTutorials = useContractTutorials({
    link: insuranceLink,
    operation,
    onPartnerAccess: handlePartnerSpaceClick,
  });

  return (
    <div className={styles.card}>
      <div className={styles.cardTop}>
        {family ? (
          <span className={styles.familyName}>
            {FamilleCardReprendreSouscription[family as keyof typeof FamilleCardReprendreSouscription]}
          </span>
        ) : (
          <div className={styles.contractName}>{contractName}</div>
        )}
        {isLogo && (
          <div
            className={styles.insuranceLogo}
            style={{
              backgroundImage: `url("${insuranceLogo}")`,
            }}
          ></div>
        )}
      </div>
      <div className={styles.cardBottom}>
        {family ? (
          <div className={styles.stockCard}>
            <span className={styles.contractName}>{contractName}</span>
            <p className={styles.contractDescription}>{t('cardGererContrat.familyDescription')}</p>
          </div>
        ) : (
          <p>{description ?? t('cardGererContrat.description')}</p>
        )}
        {contractTutorials.showOperationTutorial ? (
          <div className={styles.tutorialBlock}>
            <p>{t('videoTutorials.exitGuide')}</p>
            <ContractTutorials state={contractTutorials} />
          </div>
        ) : (
          <ContractTutorials state={contractTutorials} />
        )}
        <MtxGrid row className={styles.buttonsRow}>
          <MtxButton
            variant="tertiary"
            size="small"
            full-width="false"
            className={styles.manageContractBtn}
            onClick={handlePartnerSpaceClick}
          >
            <div>{t('cardGererContrat.partnerSpaceBtn')}</div>
            <div slot="end-icon" className={styles.externalLinkIcon}>
              <i className="totem-icon totem-icon-external-link"></i>
            </div>
          </MtxButton>
          {onRequestCancellation && (
            <MtxButton
              variant="tertiary"
              size="small"
              full-width="false"
              className={styles.manageContractBtn}
              onClick={onRequestCancellation}
            >
              <div>{cancelLabel}</div>
            </MtxButton>
          )}
        </MtxGrid>
        {isAsideInfo && <p className={styles.asideInfo}>{t('cardGererContrat.comingSoon')}</p>}
      </div>
    </div>
  );
};

export default CardGererContrat;
